export default "__VITE_ASSET__DNMU9k8O__"